"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/http");
var DynamicBase_1 = require("./DynamicBase");
var DynamicCache_1 = require("./DynamicCache");
var DynamicComponentMetadata = (function () {
    function DynamicComponentMetadata(selector, template) {
        if (selector === void 0) { selector = 'DynamicComponent'; }
        if (template === void 0) { template = ''; }
        this.selector = selector;
        this.template = template;
    }
    return DynamicComponentMetadata;
}());
exports.DynamicComponentMetadata = DynamicComponentMetadata;
var DynamicComponent = (function (_super) {
    __extends(DynamicComponent, _super);
    function DynamicComponent(dynamicExtraModules, viewContainer, compiler, http, dynamicCache) {
        return _super.call(this, dynamicExtraModules, viewContainer, compiler, http, dynamicCache, 'DynamicComponent{id}') || this;
    }
    return DynamicComponent;
}(DynamicBase_1.DynamicBase));
DynamicComponent.decorators = [
    { type: core_1.Component, args: [{
                selector: 'DynamicComponent',
                template: ''
            },] },
];
/** @nocollapse */
DynamicComponent.ctorParameters = function () { return [
    { type: Array, decorators: [{ type: core_1.Inject, args: [DynamicBase_1.DYNAMIC_TYPES.DynamicExtraModules,] },] },
    { type: core_1.ViewContainerRef, decorators: [{ type: core_1.Inject, args: [core_1.ViewContainerRef,] },] },
    { type: core_1.Compiler, decorators: [{ type: core_1.Inject, args: [core_1.Compiler,] },] },
    { type: http_1.Http, decorators: [{ type: core_1.Inject, args: [http_1.Http,] },] },
    { type: DynamicCache_1.DynamicCache, decorators: [{ type: core_1.Inject, args: [DynamicCache_1.DynamicCache,] },] },
]; };
DynamicComponent.propDecorators = {
    'dynamicComponentReady': [{ type: core_1.Output },],
    'dynamicComponentBeforeReady': [{ type: core_1.Output },],
    'componentType': [{ type: core_1.Input },],
    'componentTemplate': [{ type: core_1.Input },],
    'componentStyles': [{ type: core_1.Input },],
    'componentContext': [{ type: core_1.Input },],
    'componentTemplateUrl': [{ type: core_1.Input },],
    'componentTemplatePath': [{ type: core_1.Input },],
    'componentDefaultTemplate': [{ type: core_1.Input },],
    'componentRemoteTemplateFactory': [{ type: core_1.Input },],
    'componentModules': [{ type: core_1.Input },],
};
exports.DynamicComponent = DynamicComponent;
//# sourceMappingURL=DynamicComponent.js.map


//////////////////
// WEBPACK FOOTER
// ./~/angular2-dynamic-component/DynamicComponent.js
// module id = 207
// module chunks = 3